import tinycolor from 'tinycolor2';

window.tinycolor = window.tinycolor != null ? window.tinycolor : tinycolor;
export { tinycolor };
export default window.tinycolor;
